import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { documentationRootGuid } from '@constants'
import { Alert, Button, Divider, Stack } from '@mui/material'
import { Form2 } from '@ui/forms'
import { useModelStore } from '@editorStores'
import { todayStringDE } from '@utils'
import BaseFormFields from '../../../BaseFormFields'
import FormFields from './components/FormFields'

type DefaultValues = TitlePageItemConfig & {
  project_description: string
  address_street: string
  address_city: string
  address_zip_code: string
  owner_name: string
  owner_address: string
  responsible_user_name: string
  primary_editor_name: string
}

interface Props {
  item: FileItem
  mutate: (data: TitlePageItemConfig) => void
}

const TitlePageForm = ({ item, mutate }: Props) => {
  const navigate = useNavigate()

  const project = useModelStore(state => state.project)

  const defaultValues = useMemo(() => {
    const baseConfig: DefaultValues = {
      ...item.additional_data,
      item_guid: item.guid,
      name: item.name,
      hand_in_date: item?.additional_data?.hand_in_date ?? todayStringDE(),
      project_description: project?.description ?? '',
      address_street: project?.address.street ?? '',
      address_city: project?.address.city ?? '',
      address_zip_code: project?.address.zip_code ?? '',
      owner_name: project?.owner_name ?? '',
      owner_address: project?.owner_address ?? '',
      // The migrated participants -- the same two the exports print. The
      // deprecated responsible_engineer_name/processor_name columns are frozen
      // and no longer follow a reassignment.
      responsible_user_name: project?.responsible_user_name ?? '',
      primary_editor_name: project?.primary_editor_name ?? '',
    }

    return baseConfig
  }, [item, project])

  return (
    <Stack spacing={2} p={1}>
      <Form2
        key={JSON.stringify(defaultValues)}
        onSubmit={(data: DefaultValues) => {
          mutate(data)
        }}
        defaultValues={defaultValues}
        submitOnChange
      >
        <Stack spacing={2}>
          <BaseFormFields
            elementGuid={item.element_guid}
            showBeginOnNewPage={item.parent_guid !== documentationRootGuid}
          />

          <Divider />

          <FormFields />

          <Alert
            severity="info"
            action={
              <Button color="inherit" size="small" onClick={() => navigate('/')}>
                Zu den Projekten
              </Button>
            }
          >
            Daten können in den Projektdaten angepasst werden.
          </Alert>
        </Stack>
      </Form2>
    </Stack>
  )
}

export default TitlePageForm
